import { addHook, sanitize } from 'dompurify';
import React, { memo } from 'react';

interface IProps {
  html: any;
  [key: string]: any;
}

const setAllLinksToOpenInAnotherTab = (): void => {
  addHook('afterSanitizeAttributes', (node: Element): void => {
    if ('target' in node) {
      node!.setAttribute('target', '_blank');
      node!.setAttribute('rel', 'noreferrer');
    }
  });
};

const NoDangerouslyHTML = (props: IProps) => {
  setAllLinksToOpenInAnotherTab();
  return <div {...props} dangerouslySetInnerHTML={{ __html: sanitize(props.html) }} />;
};

export default memo(NoDangerouslyHTML);
